import { Grid, Review, ReviewGroup } from '@daren/ui-components'
import { format } from 'date-fns'
import * as React from 'react'

import { Container, Section } from '~/components/layout'
import type { SanityBlock } from '~/types/sanity'

interface SanityReview {
  rating?: 0 | 1 | 2 | 3 | 4
  title?: string
  content?: string
  author?: string
  date?: string
}

interface ContentProps {
  title?: string
  reviews?: SanityReview[]
}

export function ReviewsBlock({
  content: { title, reviews = [] } = {},
}: SanityBlock<ContentProps>) {
  return (
    <Section>
      <Grid>
        <Container size="full">
          <ReviewGroup title={title}>
            {reviews.map((review: SanityReview) => {
              return (
                <Review
                  key={review.title}
                  title={review.title}
                  rating={review.rating}
                  author={review.author}
                  date={
                    review?.date &&
                    format(new Date(review.date), 'MMMM d, yyyy')
                  }
                  datetime={review.date}
                  html={review.content}
                />
              )
            })}
          </ReviewGroup>
        </Container>
      </Grid>
    </Section>
  )
}
